import { Box, Button, Tab, Tabs } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { UserType } from '../../api/appAPI'
import GarageShopLogo from '../../assets/logoGSH.png'
import UsersInfoTab from '../../components/Admin/UsersInfoTab'
import { TabPanel } from '../../components/AppTabs'
import UserAvatar from '../../components/UserAvatar'
import { EnqueueSnackbarType } from '../../components/common/Helpers'
import { CompanyType, editUser, getConfigs } from '../../redux/appReducer'
import { StateType } from '../../redux/store'
import Costumers from './Costumers/Costumers'
import Settings from './Settings'
import FloorMaterialsTab from './FloorMaterials/FloorMaterialsTab'

interface IProps {
  user: undefined | UserType
  company: undefined | CompanyType
  isGSH: boolean
  fmTabAvailable: boolean

  editUser(user: UserType, enqueueSnackbar: EnqueueSnackbarType): void
  getConfigs(): void
}

const Profile: FC<IProps> = (props) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!props.user) {
      navigate('/login')
    }

    props.getConfigs()
  }, [])

  const [activeTab, setActiveTab] = useState(2)

  if (!props.user) return <></>

  return (
    <Box>
      <Box
        sx={{
          mt: 2,
          width: 1,
          display: 'flex',
          justifyContent: 'center',
          borderBottom: 1,
          borderColor: 'divider',
          position: 'relative',
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Customers" value={0} />
          {(props.user.role === 'admin' || props.user.role === 'company') && (
            <Tab label="Users" value={1} />
          )}

          <Tab label="Settings" value={2} />
          {props.fmTabAvailable && <Tab label="Floor Materials" value={3} />}
        </Tabs>

        {props.user.ghlUrl && (
          <Button
            variant="contained"
            size="small"
            sx={{ height: 36, position: 'absolute', top: 0, right: 60 }}
            onClick={() => window.open(props.user?.ghlUrl, '_blank')}
          >
            Training & Billing
          </Button>
        )}

        <UserAvatar forProfile />

        {props.isGSH && (
          <>
            <img
              style={{
                position: 'absolute',
                left: 10,
                top: -8,
              }}
              height={45}
              src={GarageShopLogo}
              alt="logo"
            />

            <img
              style={{
                position: 'absolute',
                right: props.user.ghlUrl ? 250 : 60,
                top: -8,
              }}
              height={45}
              src={props.company?.logoURL}
              alt="company logo"
            />
          </>
        )}
      </Box>

      <TabPanel value={activeTab} index={0}>
        <Costumers />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <UsersInfoTab />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <Settings user={props.user} editUser={props.editUser} />
      </TabPanel>
      <TabPanel value={activeTab} index={3}>
        <FloorMaterialsTab user={props.user} />
      </TabPanel>

      {/* <Box
                sx={{
                    position: 'absolute', top: 0, left: 0,
                    display: 'flex', columnGap: 1, p: 2,
                    alignItems: 'center'
                }}
            >
                <Typography variant='subtitle1'>Go to</Typography>

                <Button style={{ textTransform: 'none' }} size="medium" color='primary' variant="contained"
                    onClick={() => {
                        window.location.pathname = '/dev'
                    }}>Design Tool</Button>

                <Link to='/' style={{ textDecoration: 'none', color: 'black' }}>
                    <Button style={{ textTransform: 'none' }} size="medium" color='primary' variant="contained" >Cabinet Configurator</Button>
                </Link>
            </Box> */}
    </Box>
  )
}

const mapStateToProps = (state: StateType) => ({
  user: state.appReducer.user,
  company: state.appReducer.company,
  isGSH: state.appReducer.isGSH,
  fmTabAvailable: state.appReducer.fmTabAvailable,
})

export default connect(mapStateToProps, {
  editUser,
  getConfigs,
})(Profile)
